import { render, staticRenderFns } from "./Rate.vue?vue&type=template&id=fe8c77ca&"
import script from "./Rate.vue?vue&type=script&lang=js&"
export * from "./Rate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports